const BrandClass = Object.freeze({
	Base: 'm-brand',
	// Colors
	White: 'm-brand--white',
});

export { BrandClass };
